/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ViewContext from '../../../../ViewContext';
import icActivity from '../../../../assets/svgs/ic-activity.svg';
import strings from '../../../../assets/strings.json';
import HauxButton from '../../../../components/HauxButton';
import '../sheduleCard.scss';

const {
  DATE_FORMATS,
} = strings;

function HauxTrainingCard({
  contentMeetings,
}) {
  const history = useHistory();
  const { setSelected } = useContext(ViewContext);

  return (
    <Paper>
      <Grid container direction="column" className="cardContainer">
        <div className="titleCardContainer">
          <img src={icActivity} alt="" style={{ height: 25 }} />
          <span className="h6StylePurple spaceLeftTitle">Haux training</span>
          <div className="positionRoom">
            <span className="cardRoom" style={{ background: 'rgb(245, 122, 61)' }}>Sala Fit</span>
          </div>
        </div>
        <Grid container direction="row">
          {contentMeetings.map((
            item,
          ) => (
            <>
              <div className="spaceCardSubtitle">
                <span className="paragraph">{`Aula ${item.room}`}</span>
                <span className="hourText">{moment(item.start).format(DATE_FORMATS.HOUR)}</span>
              </div>
              <div className="borderCard" />
            </>
          ))}
        </Grid>
        <div className="buttonCardContainer">
          <HauxButton
            type="secondary"
            text="Ver agenda"
            onClick={() => {
              history.push('/schedule/training');
              setSelected(1);
            }}
          />
        </div>
      </Grid>
    </Paper>
  );
}

HauxTrainingCard.propTypes = {
  contentMeetings: PropTypes.array,
};
HauxTrainingCard.defaultProps = {
  contentMeetings: [],
};

export default HauxTrainingCard;
